export default "__VITE_ASSET__DNihP0Xr__"